class VideoHandler {
  constructor(container) {
    this.container = container;
    this.video = container.querySelector('video');
    this.control = container.querySelector('[data-video-control]');
    this.playing = false;

    this.init();
  }

  init() {
    // Check if video is inside a carousel (Flickity)
    const isInCarousel = this.container.closest('.product-main-carousel');

    // Toggle on click for control button
    if (this.control) {
      this.control.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.togglePlay();
      });
    }

    // Only add container click/touch handling if:
    // 1. Video doesn't have .card-video class
    // 2. Video is NOT inside a carousel (to allow Flickity swipe gestures)
    if (this.container && !this.video.classList.contains('card-video') && !isInCarousel) {
      this.container.addEventListener('click', (e) => {
        // Don't handle click if it was on the control button
        if (!e.target.closest('[data-video-control]')) {
          e.preventDefault();
          e.stopPropagation();
          this.togglePlay();
        }
      });

      // Handle touch events for mobile (desktop only, not carousel)
      this.container.addEventListener('touchend', (e) => {
        // Don't handle touch if it was on the control button
        if (!e.target.closest('[data-video-control]')) {
          e.preventDefault();
          e.stopPropagation();
          this.togglePlay();
        }
      });
    }

    // Intersection Observer for lazy loading and autoplay
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Autoplay video when it comes into view
          this.video.play().catch(() => {
            // Handle autoplay failure
            console.log('Autoplay prevented');
          });
          this.setPlayingState(true);
        } else {
          this.video.pause();
          this.setPlayingState(false);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(this.container);
  }

  setPlayingState(isPlaying) {
    this.playing = isPlaying;
    this.container.setAttribute('data-playing', isPlaying);
  }

  togglePlay() {
    if (this.video.paused) {
      this.video.play();
      this.setPlayingState(true);
    } else {
      this.video.pause();
      this.setPlayingState(false);
    }
  }
}

// Initialize Flickity and video handlers when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all video containers
  document.querySelectorAll('[data-video-container]').forEach(container => {
    new VideoHandler(container);
  });

  // Initialize mobile carousel
  var mobileCarousel = document.querySelector('.MobileGallery .product-main-carousel');
  if (typeof Flickity !== 'undefined' && mobileCarousel) {
    // Get media count from data attribute or calculate it
    var mediaCount = mobileCarousel.querySelectorAll('.image-wrapper').length;
    var showPageDots = mediaCount > 1;

    var flkty = new Flickity(mobileCarousel, {
      lazyLoad: 1, // Preload 1 image ahead
      adaptiveHeight: true,
      prevNextButtons: false,
      pageDots: showPageDots,
      freeScroll: false,
      percentPosition: false,
      dragThreshold:1,
      on: {
        ready: function() {
          // Remove 'loading' class and fade images in
          mobileCarousel.classList.remove('product-main-carousel--loading');
          mobileCarousel.classList.add('is-initialized');
        },
      },
    });
  }
});
